<template>
<div class="row">
   <div class="col-md-12 col-lg-12 aos-init aos-animate content d-flex flex-column mt-1 mb-5 mx-auto" data-aos="fade-up" data-aos-delay="100">
     
    <!--begin::Dashboard-->
    <div class="row">
      <div class="col-xxl-4">
        <div class="card card-row d-flex flex-row mb-4">
         <DailyPay v-bind:data_series="daily"></DailyPay>
        </div>
      </div>
      <div class="col-xxl-4">
        <div class="card card-row d-flex flex-row mb-4">
        <AmmountPay v-bind:data_series="ammount"></AmmountPay>
        </div>
      </div>
      <div class="col-xxl-4">
        <div class="card card-row d-flex flex-row mb-4" style="max-height: 332px">
        <MethodPay v-bind:data_series="methods"></MethodPay>
        </div>
      </div>
    </div>
    <!--end::Dashboard-->
    </div>
  </div>
</template>


<script>

import { mapState } from "vuex";
import DailyPay from "@/view/content/widgets/stats/DailyPay.vue";
import AmmountPay from "@/view/content/widgets/stats/AmmountPay.vue";
import MethodPay from "@/view/content/widgets/stats/MethodPay.vue";
import { GET_STATS_DAILY, GET_STATS_AMMOUNT, GET_STATS_METHODS } from "@/core/services/store/stats.module";
import moment from 'moment'
moment.locale( 'es' );

export default {
  name: "dashboard",
  components: {
    MethodPay,
    AmmountPay,
    DailyPay
  },
  data() {
    return {
      loading:true,
     
      sucursal:"",
      codigoMedioPago: '',
      order:{},
      form: {
        documento: "",
        
        desde: "",
        hasta: ""
      },
      deudaTotal:0,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '$ ',
        suffix: '',
        precision: 0,
        masked: false
      }
    };
  },
  mounted () {
    this.getDaily();
    this.getAmmounts();
    this.getMethodStats();
  },
  
  methods: {
    getDaily(params = null) {
      this.$Progress.start();
      this.$store
          .dispatch(GET_STATS_DAILY, params)
          .then(()=>{
            this.$Progress.finish()});
    },
    getAmmounts(params = null) {
      this.$Progress.start();
      this.$store
          .dispatch(GET_STATS_AMMOUNT, params)
          .then(()=>{
            this.$Progress.finish()});
    },
    getMethodStats(params = null) {
      this.$Progress.start();
      this.$store
          .dispatch(GET_STATS_METHODS, params)
          .then(()=>{
            this.$Progress.finish()});
    },
  },
  filters:{
    formatDate(value) {
        const duration = moment(value).format('DD/MM/yyyy');
        return `${duration}`;
    },

    formatTime(value) {
        const hora = moment(value).format('HH:mm:ss');
        return `${hora}`;
    }
  },
  computed: {
    ...mapState({
      errors: state => state.errors,
      client: state => state.auth.user,
      daily: state => state.stats.dailyStats,
      ammount: state => state.stats.dailyAmmountStats,
      methods: state => state.stats.methodStats
    })
  }
};
</script>
<style>
.b-form-datepicker {min-width:130px;}
.b-form-datepicker label {
        padding-bottom: 3px !important;
    padding-top: 6px;
    text-transform: none;
    white-space: nowrap !important;
    font-size: 1rem !important;
}
.b-form-datepicker .btn:not(:disabled):not(.disabled) {
    cursor: pointer;
    padding: 10px 5px;
}
.d-content-full{width:100%;}
</style>
